import React, { useState, useEffect } from 'react';
import { loadOrg } from '../../api/api';
import { setProblemCategory } from '../../api/settingApi';
import { useNavigate } from 'react-router-dom';

const NewCategory = () => {
    const navigate = useNavigate();
    const user = JSON.parse(sessionStorage.getItem('lgusr'));
    const isAdmin = user?.role === 'ADMINISTRATOR';
    const org_id = user?.orgId;

    const [organizations, setOrganizations] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        organizationId: isAdmin ? '' : org_id,
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isAdmin) {
            const fetchOrganizations = async () => {
                setLoading(true);
                try {
                    const response = await loadOrg();
                    setOrganizations(response);
                } catch (error) {
                    console.error('Error fetching organizations:', error);
                    setOrganizations([]); // Fallback to an empty array on error
                } finally {
                    setLoading(false);
                }
            };
            fetchOrganizations();
        }
    }, [isAdmin]);

    const validate = () => {
        const newErrors = {};
        if (!formData.name) {
            newErrors.name = 'Category Name is required';
        }
        if (!formData.organizationId) {
            newErrors.organizationId = 'Please select an organization';
        }
        return newErrors;
    };

    const handleSubmit = async (e) => {
        console.log(formData);
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});
        try {
            const response = await setProblemCategory(formData);
            console.log(response);
            navigate('/settings');
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    return (
        <div className="flex justify-center items-center h-screen">
            <form onSubmit={handleSubmit} className="bg-white shadow-lg rounded-xl px-8 pt-6 pb-8 w-full max-w-md border-2 border-teal-300">
                <h2 className="text-3xl font-extrabold text-blue-700 text-center mb-6">Problem Category</h2>

                <div>
                    <label className="block text-sm font-medium text-gray-800">Category Name</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange}
                        className="block w-full px-4 py-3 mt-2 border rounded-lg focus:ring-2 focus:ring-teal-500"
                    />
                    {errors.name && (
                        <p className="text-red-600 text-sm mt-1">{errors.name}</p>
                    )}
                </div>

                {isAdmin && (
                    <div className="mt-4">
                        <label className="block text-sm font-medium text-gray-800">Organization</label>
                        <select
                            name="organizationId"
                            value={formData.organizationId}
                            onChange={handleChange}
                            className="block w-full px-4 py-3 mt-2 border rounded-lg focus:ring-2 focus:ring-teal-500"
                        >
                            <option value="" disabled>Select an organization</option>
                            {organizations.map((org) => (
                                <option key={org.id} value={org.id}>
                                    {org.name}
                                </option>
                            ))}
                        </select>
                        {errors.organizationId && (
                            <p className="text-red-600 text-sm mt-1">{errors.organizationId}</p>
                        )}
                    </div>
                )}

                {/* Submit Button */}
                <div className="mt-6">
                    <button type="submit" className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-6 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-orange-500">
                        Submit
                    </button>
                </div>
            </form>
        </div>
    );
};

export default NewCategory;
